import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

const defaultClose = () => global.history.go(-1)

const WideLayoutContext = createContext(null)

export const WideLayoutProvider = ({ children, defaultOnClose = defaultClose }) => {
  const pageCloseHandlerRef = useRef(null)
  const defaultOnCloseRef = useRef(defaultOnClose)

  defaultOnCloseRef.current = defaultOnClose

  const registerCloseHandler = useCallback((handler) => {
    pageCloseHandlerRef.current = handler

    return () => {
      if (pageCloseHandlerRef.current === handler) {
        pageCloseHandlerRef.current = null
      }
    }
  }, [])

  const invokeClose = useCallback((event) => {
    const handler = pageCloseHandlerRef.current ?? defaultOnCloseRef.current ?? defaultClose
    handler(event)
  }, [])

  const value = useMemo(
    () => ({
      registerCloseHandler,
      invokeClose,
    }),
    [registerCloseHandler, invokeClose],
  )

  return <WideLayoutContext.Provider value={value}>{children}</WideLayoutContext.Provider>
}

WideLayoutProvider.propTypes = {
  children: PropTypes.node,
  defaultOnClose: PropTypes.func,
}

export const useWideLayoutContext = () => useContext(WideLayoutContext)
